module.exports = "/assets/data/6d4e9c0f30738afadd0068a89cf761ca-HX6.data.json";